module.exports = __webpack_public_path__ + "img/CY110022.f409d02c.png";